import {type NoncePayload, type Collect, type CollectOptions, type PoyntOptions} from './types';

declare const TokenizeJs: TokenizeJs;

type Token = {nonce?: string; error?: string};

class PoyntCardElement {
	private readonly businessId: string;
	private readonly applicationId: string;

	private readonly $cardElement: Collect;

	constructor(options: PoyntOptions) {
		this.businessId = options.businessId;
		this.applicationId = options.applicationId;

		this.$cardElement = new TokenizeJs(this.businessId, this.applicationId);
	}

	public mount(selector: string, options: CollectOptions) {
		this.$cardElement.mount(selector, document, options);
	}

	public async tokenize(payload: NoncePayload): Promise<Token> {
		return new Promise(resolve => {
			this.$cardElement.on('nonce', payload => {
				if (payload.data.nonce) {
					resolve({nonce: payload.data.nonce});
				}
			});

			this.$cardElement.on('error', error => {
				resolve({error: error.data?.message ?? error.data?.error?.message ?? 'Something went wrong. Please try again.'});
			});

			this.$cardElement.getNonce(payload);
		});
	}
}

export {
	type Token,
	PoyntCardElement,
};
